import { CssBaseline as MUIBaseLine } from '@mui/material';
import { isElectron } from '../helpers/EnvironmentFlags/EnvironmentFlags';

/**
 * Sets up a reset.css type baseline.
 *
 * On the kiosk (Electron) build it also makes all non-editable content
 * unselectable. Chromium's touch text-selection bar (Copy/Cut) only appears
 * once a selection exists, so removing selectability on static text prevents
 * the long-press menu. Editable fields are intentionally unaffected — Blink
 * ignores `user-select` on editing hosts — so typing, caret, select-all and
 * the phone-mask logic keep working. Gated on isElectron() so mobile-web
 * selection/copy is left untouched.
 */
export const CssBaseLine = () => {
    return (
        <>
            <MUIBaseLine />
            {isElectron() ? (
                <style data-testid={'kioskSelectionSuppression'}>
                    {'body { -webkit-user-select: none; user-select: none; }'}
                </style>
            ) : null}
        </>
    );
};
